import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";

import { useTranslation } from "react-i18next";
import { prepareSelectData } from "../../utils/commonHelper";
import SelectDropdown from "../SelectDropdown";

const VehicleValuationForm = ({
  vehicleDescriptionData,
  selectedVehicleDescription,
  handleInputChange,
  formData,
}) => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const selectedProduct = JSON.parse(localStorage.getItem("product_details"));
  const [touched, setTouched] = useState(false);
  const [isValid, setIsValid] = useState(true);

  console.log("FBdfdff ",selectedVehicleDescription);

    const normalizedData = Array.isArray(vehicleDescriptionData)
    ? vehicleDescriptionData
    : vehicleDescriptionData
    ? [vehicleDescriptionData]
    : [];
  

   useEffect(() => {
    const valuation = Number(formData?.vehicle_valuation);
    setIsValid(
      valuation &&
        valuation >= selectedVehicleDescription?.trade_price &&
        valuation <= selectedVehicleDescription?.retail_price
    );
  }, [formData, formData?.vehicle_valuation]);


  const showValidation = touched;

  // ✅ Use normalizedData.length instead of vehicleDescriptionData?.length
  const shouldRenderForm =
    selectedProduct?.product_id === 1 &&
    selectedProduct?.sub_product_id === 21 &&
    normalizedData.length > 0;

   let options = prepareSelectData(normalizedData, "admeid", currentLanguage);
  if (!shouldRenderForm) return null;

  // ✅ Use normalizedData
 
  // let options = prepareSelectData(
  //   vehicleDescriptionData,
  //   "admeid",
  //   currentLanguage
  // );

  return (
    <Container>
      <Row>
        <Col md={12}>
          <SelectDropdown
            name="admeid"
            placeholder={t("selectAdmeid")}
            options={options}
            handleOnChange={handleInputChange}
            required={true}
            isSearchable={true}
            forceEnglishFont={true}
            defaultValue={{
              value: selectedVehicleDescription?.admeid,
              label: selectedVehicleDescription?.description,
            }}
          />
        </Col>
        {selectedVehicleDescription ? (
          <>
            <Col md={12}>
              <input
                type="number"
                name="vehicle_valuation"
                placeholder={t("vehicleValue")}
                className={`form-control element-style my-3 ${
                  showValidation ? (isValid ? "is-valid" : "is-invalid") : ""
                }`}
                onChange={(e) =>
                  handleInputChange(e.target.name, e.target.value)
                }
                onBlur={() => setTouched(true)}
                required
                value={formData?.vehicle_valuation || ""}
                min={selectedVehicleDescription?.trade_price}
                max={selectedVehicleDescription?.retail_price}
              />
              <span className="form-label text-mute">
                {t("vehicleValueRangeText", {
                  startRange: selectedVehicleDescription?.trade_price,
                  endRange: selectedVehicleDescription?.retail_price,
                })}
              </span>
              <div className={isValid ? "valid-feedback" : "invalid-feedback"}>
                {isValid
                  ? t("vehicleValueRangeTextValid")
                  : t("vehicleValueRangeTextInValid", {
                      startRange: selectedVehicleDescription?.trade_price,
                      endRange: selectedVehicleDescription?.retail_price,
                    })}
              </div>
            </Col>
            <Col md={12} className="text-center">
              <button
                type="submit"
                className="btn h-btn my-3"
                disabled={!isValid}
              >
                {t("quoteBtnTxt")}
              </button>
            </Col>
          </>
        ) : (
          ""
        )}
      </Row>
    </Container>
  );
};

export default VehicleValuationForm;
